import { Button, Flex, TimePicker } from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";
import useAvailability from "../../hooks/useAvailability";
import { TimeInputProps } from "../../types/date";
import classes from "./timeInput.module.css";

const TimeInput = ({ value, appointmentId }: TimeInputProps) => {
  const { deleteAvailability, deleteLoading } = useAvailability();

  return (
    <Flex gap={8}>
      <TimePicker.RangePicker
        value={value}
        inputReadOnly
        open={false}
        variant="borderless"
        needConfirm={false}
        size="small"
        format="HH:00"
        disabled
        suffixIcon={null}
        allowClear={false}
        className={classes.time}
      />
      <Button
        type="text"
        icon={<MinusCircleOutlined />}
        disabled={deleteLoading}
        loading={deleteLoading}
        onClick={() => {
          deleteAvailability(appointmentId);
        }}
      />
    </Flex>
  );
};

export default TimeInput;
